import { createFileRoute } from '@tanstack/react-router'
import { CoursesDoradcaList } from '../../pages/Courses/CoursesDoradcaList'

export const Route = createFileRoute('/(app)/_app/courses_/kurs-doradca-podatkowy')({
  component: CoursesDoradcaList,
})